import React from 'react';
import isEmpty from 'lodash/isEmpty';
import upperFirst from 'lodash/upperFirst';
import { ToastMessageTitle, ToastMessageContentSuppliers } from './PreferredSuppliersToastMessage';

const getTitleAndContentForToastMessage = ({ addedSuppliers, deletedSuppliers, noun = 'supplier' }) => {
  if (!isEmpty(addedSuppliers) && isEmpty(deletedSuppliers)) {
    return {
      title: <ToastMessageTitle title={`New ${noun} added to your preferences`} />,
      content: <ToastMessageContentSuppliers suppliers={addedSuppliers} added noun={noun} />,
    };
  }

  if (isEmpty(addedSuppliers) && !isEmpty(deletedSuppliers)) {
    return {
      title: <ToastMessageTitle title={`${upperFirst(noun)} deleted from your preferences`} />,
      content: <ToastMessageContentSuppliers suppliers={deletedSuppliers} noun={noun} />,
    };
  }

  return {
    title: <ToastMessageTitle title={`A change was made to your ${noun} preferences`} />,
    content: (
      <>
        <ToastMessageContentSuppliers suppliers={addedSuppliers} added bold noun={noun} />{' '}
        <ToastMessageContentSuppliers suppliers={deletedSuppliers} bold noun={noun} />
      </>
    ),
  };
};

export default getTitleAndContentForToastMessage;
